import { React, useState } from "react";

export const RegistrationRequirementNotice = ({
  categories,
  registrationTypes,
  formData,
}) => {
  const missingCategory = categories.length > 0 && !formData.category;
  const missingRegistrationType =
    registrationTypes.length > 0 && !formData.registrationType;

  if (!missingCategory && !missingRegistrationType) {
    return null;
  }

  return (
    <div className="grid-item grid-item--full" style={{ marginBottom: "15px" }}>
      <div
        style={{
          padding: "12px 16px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffc107",
          borderRadius: "6px",
          fontSize: "14px",
          color: "#856404",
        }}
      >
        <strong>⚠️ Required Information:</strong> Please select{" "}
        {categories.length > 0 && registrationTypes.length > 0 ? (
          <>
            both <strong>Category</strong> and{" "}
            <strong>Registration Type</strong>
          </>
        ) : categories.length > 0 ? (
          <strong>Category</strong>
        ) : (
          <strong>Registration Type</strong>
        )}{" "}
        to proceed.{" "}
        {categories.length > 0 && registrationTypes.length > 0
          ? "These fields are"
          : "This field is"}{" "}
        mandatory.
      </div>
    </div>
  );
};

export const DepartmentSelectionSection = ({
  formData,
  departments,
  onChange,
  onDepartmentChange,
}) => {
  if (departments.length === 0) {
    return null;
  }

  return (
    <>
      <div className="grid-item">
        <label
          style={{
            display: "block",
            marginBottom: "5px",
            color: "#000",
            fontWeight: "500",
            fontSize: "14px",
          }}
        >
          Department
        </label>
        <select
          name="department"
          value={formData.departmentId || ""}
          onChange={onDepartmentChange}
        >
          <option value="">Department</option>
          {departments.map((department) => (
            <option key={department.id} value={department.id}>
              {department.value}
            </option>
          ))}
        </select>
      </div>
      {formData.department === "Others" && (
        <div className="grid-item">
          <input
            name="otherDepartment"
            placeholder="Please specify department"
            value={formData.otherDepartment}
            onChange={onChange}
          />
        </div>
      )}
    </>
  );
};

export const ComboWorkshop = ({
  focusedSessions = [],
  focusedSessionAvailability = {},
  selectedComboWorkshop,
  handleComboWorkshopChange,
  formData,
}) => {
  const registrationType = String(formData?.registrationType || "");

  const isCombo = registrationType.toLowerCase().includes("workshop");

  return (
    <>
      {isCombo && (
        <div className="grid-item grid-item--full">
          <div>
            <label
              style={{
                display: "block",
                marginBottom: "10px",
                fontWeight: "500",
                color: "#000",
              }}
            >
              Please select the Workshop you would like to attend:
            </label>

            {focusedSessions.map((item) => {
              const availability = focusedSessionAvailability[item.id];

              const availableSeats = availability?.available_seats ?? 0;

              const isDisabled = availableSeats <= 0;

              return (
                <label
                  key={item.id}
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "10px",
                    color: isDisabled ? "#999" : "#000",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="focusedWorkshop"
                    value={item.value}
                    checked={selectedComboWorkshop === item.value}
                    onChange={handleComboWorkshopChange}
                    disabled={isDisabled}
                  />

                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <span>{item.value}</span>

                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "13px",
                        color: isDisabled ? "#dc3545" : "#198754",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {isDisabled ? "Seat Filled" : `${availableSeats} Seats`}
                    </span>
                  </span>
                </label>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export const CategoryRegistrationSelectionSection = ({
  formData,
  categories,
  registrationTypes,
  previousCategoriesHistory,
  previousRegistrationTypesHistory,
  renderHistoryPills,
  onCategoryChange,
  onRegistrationTypeChange,
}) => (
  <>
    {categories.length > 0 && (
      <>
        {formData.paid &&
          previousCategoriesHistory.length > 0 &&
          renderHistoryPills(previousCategoriesHistory, "Categories")}

        <div className="grid-item">
          <label
            style={{
              display: "block",
              marginBottom: "5px",
              color: "#000",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            Category <span style={{ color: "#dc3545" }}>*</span>
            {formData.paid && previousCategoriesHistory.length > 0 && (
              <span
                style={{
                  fontWeight: "400",
                  color: "#666",
                  fontSize: "13px",
                  marginLeft: "8px",
                }}
              >
                (Add another)
              </span>
            )}
          </label>
          <select
            name="category"
            value={formData.categoryId || ""}
            onChange={onCategoryChange}
            required
            style={{ borderColor: !formData.category ? "#dc3545" : "" }}
          >
            <option value="" disabled hidden>
              Select Category
            </option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.value}
              </option>
            ))}
          </select>
        </div>
      </>
    )}

    {registrationTypes.length > 0 && (
      <>
        {formData.paid &&
          previousRegistrationTypesHistory.length > 0 &&
          renderHistoryPills(
            previousRegistrationTypesHistory,
            "Registration Types",
          )}

        <div className="grid-item">
          <label
            style={{
              display: "block",
              marginBottom: "5px",
              color: "#000",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            Registration Type <span style={{ color: "#dc3545" }}>*</span>
            {formData.paid && previousRegistrationTypesHistory.length > 0 && (
              <span
                style={{
                  fontWeight: "400",
                  color: "#666",
                  fontSize: "13px",
                  marginLeft: "8px",
                }}
              >
                (Add another)
              </span>
            )}
          </label>
          <select
            name="registrationType"
            value={formData.registrationTypeId || ""}
            onChange={onRegistrationTypeChange}
            required
            style={{
              borderColor: !formData.registrationType ? "#dc3545" : "",
            }}
          >
            <option value="" disabled hidden>
              Select Registration Type
            </option>
            {registrationTypes.map((registrationType) => (
              <option key={registrationType.id} value={registrationType.id}>
                {registrationType.value}
              </option>
            ))}
          </select>
        </div>
      </>
    )}
  </>
);

{
  /* Tracks Fields */
}

export const RegistrationDocumentFieldsSection = ({
  formData,
  studentIdCardError,
  onChange,
  onStudentIdCardUpload,
}) => {
  const isStudent =
    (formData.category &&
      formData.category.toLowerCase().includes("student")) ||
    (formData.registrationType &&
      formData.registrationType.toLowerCase().includes("student"));
  const requiresIsaMembership =
    formData.category &&
    formData.category.toString().toLowerCase().includes("isa") &&
    !formData.category.toString().toLowerCase().includes("non") &&
    !formData.category.toString().toLowerCase().includes("isccm");

  return (
    <>
      {isStudent && (
        <div className="grid-item grid-item--full">
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "500",
              fontSize: "14px",
              color: "#000",
            }}
          >
            Student ID Card * (Single file: JPEG or PDF, max 5MB)
          </label>
          <label
            htmlFor="student-id-card-upload"
            style={{
              display: "inline-block",
              padding: "10px 16px",
              backgroundColor: "#0d6efd",
              color: "#fff",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
          >
            Upload ID
          </label>
          <input
            id="student-id-card-upload"
            type="file"
            name="studentIdCard"
            accept=".jpg,.jpeg,.pdf,image/jpeg,application/pdf"
            onChange={onStudentIdCardUpload}
            multiple={false}
            style={{ display: "none" }}
          />
          {studentIdCardError && (
            <div
              style={{
                color: "#dc3545",
                fontSize: "12px",
                marginTop: "5px",
              }}
            >
              {studentIdCardError}
            </div>
          )}
          {formData.studentIdCardName && !studentIdCardError && (
            <div
              style={{
                color: "#28a745",
                fontSize: "12px",
                marginTop: "5px",
              }}
            >
              ✓ {formData.studentIdCardName}
            </div>
          )}
          {!formData.studentIdCardName &&
            formData.studentIdCard === "DATABASE" &&
            !studentIdCardError && (
              <div
                style={{
                  color: "#28a745",
                  fontSize: "12px",
                  marginTop: "5px",
                }}
              >
                ✓ Student ID card previously uploaded (on file)
              </div>
            )}
          {!formData.studentIdCardName &&
            formData.studentIdCard &&
            formData.studentIdCard !== "DATABASE" &&
            !formData.studentIdCard.startsWith("data:") &&
            !studentIdCardError && (
              <div
                style={{
                  color: "#28a745",
                  fontSize: "12px",
                  marginTop: "5px",
                }}
              >
                ✓ Student ID card on file
              </div>
            )}
        </div>
      )}

      {formData.category === "ISCCM(Members)" && (
        <div className="grid-item">
          <input
            name="membershipNumber"
            placeholder="Enter Membership Number *"
            value={formData.membershipNumber}
            onChange={onChange}
            required
            style={{
              borderColor: !formData.membershipNumber ? "#dc3545" : "",
            }}
          />
        </div>
      )}

      {requiresIsaMembership && (
        <div className="grid-item grid-item--full">
          <input
            name="isaMembershipNumber"
            placeholder="Enter ISA Membership Number *"
            value={formData.isaMembershipNumber || ""}
            onChange={onChange}
            required
            style={{
              borderColor: !formData.isaMembershipNumber ? "#dc3545" : "",
            }}
          />
        </div>
      )}
    </>
  );
};
